module.exports = __webpack_public_path__ + "img/user-shield.c3f91679.svg";